// src/modules/components/inkind/export-utils.js
import { unparse as convertToCSV } from 'papaparse';

export const exportInKindData = (data, title, isService) => {
  if (!data || data.length === 0) {
    throw new Error('No data to export');
  }

  // Prepare CSV data
  const csvData = data.map(item => {
    const baseData = {
      'ID': item.id || '',
      'Type': isService ? item.service_type : item.offer_type,
      'Status': item.status || '',
      'User Name': item.user?.name || '',
      'User Phone': item.user?.phonenumber || '',
      'Gender': item.user?.gender || '',
      'State': item._state?.name || '',
      'City': item._city?.name || '',
      'Locality': item._locality?.name || '',
      'Created At': item.created_at ? new Date(item.created_at).toLocaleString() : '',
      'Updated At': item.updated_at ? new Date(item.updated_at).toLocaleString() : '',
    };

    if (isService) {
      // For services
      return {
        ...baseData,
        'Service Name': item.service_name || '',
        'Description': item.description || '',
      };
    } else {
      // For offers
      return {
        ...baseData,
        'Product': item.offer || '',
        'Quantity': item.quantity || '',
        'Unit': item._unit?.name || '',
        'Sub Category': item.subCategory?.name || '',
        'Description': item.description || '',
      };
    }
  });

  // Generate CSV
  const csv = convertToCSV(csvData, {
    quotes: true,
    delimiter: ",",
    header: true,
    newline: "\r\n"
  });

  // Create and download file
  const timestamp = new Date().toISOString().split('T')[0].replace(/-/g, '');
  const filename = `${title}_${timestamp}.csv`;

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);

  return filename;
};

export const createExportHandler = (data, title, isService, notify) => {
  return async () => {
    try {
      const filename = exportInKindData(data, title, isService);
      notify(`Exported ${data.length} records successfully as ${filename}!`, { type: 'success' });
    } catch (error) {
      console.error('Export error:', error);
      throw error;
    }
  };
};